import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.989}
    height={19.073}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 360278 264406"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#000;stroke-width:3992.49}.fil1{fill:#231f20}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974541797568">
        <path
          d="M262467 147853h3149V22378H94667v125475h3149v12554c16 31 37 73 58 105h164525c21-42 52-89 68-126v-12533z"
          className=""
          style={{
            fill: "none",
          }}
        />
        <path
          d="M318220 22378V1996H42057v20382h45374v125475h-3164v12533c-16 37-42 89-63 126h13675c-21-32-42-74-63-105v-12554h-3144V22378h170944v125475h-3149v12533c-16 37-47 89-68 126h13680c-21-32-47-74-63-105v-12554h-3164V22378h45368zM276069 160517c356 650 1289 2038 3468 3327l1755 1048v24908h-544c256 414 544 797 890 1085 1174 723 2295 1556 3327 2442 3380 2929 11868 13146 10563 25191-980 9043-7147 17379-16117 21775-3400 1541-6832 2301-10290 2301-3547 0-6403-797-8174-1467-10106-4197-16949-12842-17997-22609-1305-12045 7183-22262 10542-25191 1032-886 2153-1719 3332-2442 341-288 634-671 885-1085h-539v-24908l1771-1048c2132-1263 3086-2630 3458-3327H97874c356 650 1310 2038 3468 3327l1771 1048v24908h-540c252 414 540 797 886 1085 1174 723 2295 1556 3327 2442 3369 2929 11847 13146 10547 25191-959 9043-7147 17379-16117 21775-3400 1541-6821 2301-10290 2301-3547 0-6403-797-8174-1467-10091-4197-16949-12842-17997-22609-1305-12045 7178-22262 10563-25191 1032-886 2132-1719 3327-2442 340-288 634-671 885-1085h-539v-24908l1755-1048c2132-1263 3081-2630 3458-3327H1996v101892h356285V160517h-82212z"
          className="fil1"
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
